







import {
  defineComponent, onMounted, PropType, ref,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CookieDeclarationBlock',
  props: {
    blok: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  setup() {
    const scriptContainer = ref<HTMLElement | null>(null);

    onMounted(() => {
      if (scriptContainer.value) {
        const script = document.createElement('script');
        script.id = 'CookieDeclaration';
        script.src = 'https://consent.cookiebot.com/a305fcac-8ee7-4bab-aca7-6a8ed0de1627/cd.js';
        script.type = 'text/javascript';
        script.async = true;
        scriptContainer.value.append(script);
      }
    });

    return {
      scriptContainer,
    };
  },
});
